import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'bz-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent implements OnInit {

  private txId: string;
  private uniqueId: string;
  constructor(
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.txId = params.get('txId');
      this.uniqueId = params.get('uniqueId');
      this.dispatchMpiDataLoaded();
    });
  }

  dispatchMpiDataLoaded(): void {
    if (window && window.parent && window.parent.document) {
      const event = new CustomEvent('mpidataloaded',  {
        bubbles: true,
        detail: {
          mpidata: {
            txId: this.txId,
            uniqueId: this.uniqueId
          }
        }
      });
      window.parent.document.dispatchEvent(event);
    }
  }

}
